import request from './request';
const BASE_API = process.env.VUE_APP_BASE_API;
function sendHttpRequest(requests, showLoading = true) {
  return new Promise((resolve, reject) => {
    requests
      .then(response => {
        resolve(response);
        // if (parseInt(response.code) !== 2000 && parseInt(response.code) !== 4030) {
        //   reject(response); // 返回错误
        // } else {
        //   resolve(response); // 返回成功
        // }
      })
      .catch(() => {
      });
  });
}

export function post(url, param = '', prefixUrl, showLoading = true) {
  if (arguments[2] === void 0) {
    prefixUrl = BASE_API;
  }
  return sendHttpRequest(
    request({
      url: prefixUrl + url,
      method: 'post',
      data: param
    }),
    showLoading
  );
}

export function put(url, param = '', prefixUrl, showLoading = true) {
  if (arguments[2] === void 0) {
    prefixUrl = BASE_API;
  }
  return sendHttpRequest(
    request({
      url: prefixUrl + url,
      method: 'put',
      data: param
    }),
    showLoading
  );
}

export function deletes(url, param = '', prefixUrl, showLoading = true) {
  if (arguments[2] === void 0) {
    prefixUrl = BASE_API;
  }
  return sendHttpRequest(
    request({
      url: prefixUrl + url,
      method: 'delete',
      data: param
    }),
    showLoading
  );
}

export function get(url, param = '', prefixUrl = BASE_API, showLoading = true) {
  return sendHttpRequest(
    request({
      url: prefixUrl + url,
      method: 'get',
      params: param
    }),
    showLoading
  );
}

export function post_param(url, param = '', prefixUrl, showLoading = true) {
  if (arguments[2] === void 0) {
    prefixUrl = BASE_API;
  }
  return sendHttpRequest(
    request({
      url: prefixUrl + url,
      method: 'post',
      params: param
    }),
    showLoading
  );
}
